import Vue from 'vue'
import App from './App.vue'
import router from './router.js'

// axios
import axios from 'axios';
axios.defaults.baseURL = 'https://api.topfol.io/';

// sockets
import VueNativeSock from 'vue-native-websocket'
Vue.use(VueNativeSock, 'wss://api.topfol.io/tx_notify/', {
  connectManually: true,
});

//moment 
import moment from 'moment';
Vue.prototype.moment = moment;

// cryptoIcons
import Cryptoicon from 'vue-cryptoicon';
import icon from 'vue-cryptoicon/src/icons';
Cryptoicon.add(icon);
Vue.use(Cryptoicon);

// select
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

// Tooltips
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

// pagination 
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

// cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

//  charts
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

//dev extreme sankey chart
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

//notifications
import Notifications from 'vue-notification'
Vue.use(Notifications)

//mixins 
import mixins from './mixins'
Vue.mixin(mixins);

Vue.config.productionTip = false;


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

